module.exports = __webpack_public_path__ + "img/liesbeth.a06d6b6e.jpg";